import { AutogenLayoutBackOfficeStopDetails } from "./autogen/AutogenLayoutBackOfficeStopDetails";
import { Label, TableRowDisplayEvent, TableRowExpansionEvent } from "@mcleod/components";
import { StopNotesAndReferenceNumbers } from "@mcleod/dispatch/src/StopNotesAndReferenceNumbers";
import { Api, ModelRow } from "@mcleod/core";

export class BackOfficeStopDetails extends AutogenLayoutBackOfficeStopDetails {
    tableStopDetailsOnRowExpand(event: TableRowExpansionEvent) {
        const tableRow = event.getTableRow();
        const layout = event.expandComponents[0] as StopNotesAndReferenceNumbers;
        layout.tableStopComments.displayToolsCell = false;
        layout.tableStopComments.allowEdit = false;
        layout.tableStopReferenceNumbers.displayToolsCell = false;
        layout.tableStopReferenceNumbers.allowEdit = false;
        layout.sourceStopNote.search({ stop_id: tableRow.data.get("id") });
        layout.sourceReferenceNumber.search({ stop_id: tableRow.data.get("id") });
    }

    tableStopDetailsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelComments = tableRow.findComponentById("labelComments") as Label;
        if (labelComments != null) {
            Api.search("lme/general/stop-note", { stop_id: tableRow.data.get("id") }).then(response => {
                const data = response.data as ModelRow[];
                labelComments.text = data.map(row => row["comments"]).join("\n\n");
            });
        }

        const labelRefNums = tableRow.findComponentById("labelRefNums") as Label;
        if (labelRefNums != null) {
            Api.search("lme/general/reference-number", { stop_id: tableRow.data.get("id") }).then(response => {
                const data = response.data as ModelRow[];
                labelRefNums.text = data.map(row => row["reference_number"]).join("\n\n");
            });
        }
    }
}
